import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from '@adsk/alloy-react-tooltip';
import { AlertInformationIcon } from '@adsk/alloy-react-icon';
import PermissionSelect from '@adsk/alloy-react-permission-select';
import { useLocale } from '@adsk/alloy-react-helpers';
import {
  infoIconStyle,
  contentContainerStyle,
  textContainerStyle,
  permissionSelectContainerStyle,
  permissionIndicatorStyle,
} from './styles';

const ComputedPermissionsTooltip = ({
  inheritanceInfo,
  inheritedPermissionsInfo,
  permissionsIndicatorProps,
  selectType,
}) => {
  const { T } = useLocale(({ locale }) => require(`../../i18n/${locale}.json`));

  return (
    <Tooltip
      shouldWrapChildren={false}
      content={
        <div css={contentContainerStyle}>
          <div>
            {selectType === PermissionSelect.displayName ? (
              <>
                <div css={textContainerStyle}>
                  {T.translate('ACTUAL_PERMISSION')}
                </div>
                <div css={permissionSelectContainerStyle}>
                  <PermissionSelect.Indicator
                    label={permissionsIndicatorProps?.label}
                    pillCount={4}
                    pillValue={permissionsIndicatorProps?.pillValue}
                    style={permissionIndicatorStyle}
                  />
                </div>
              </>
            ) : (
              inheritedPermissionsInfo
            )}
          </div>
          <div>{inheritanceInfo}</div>
        </div>
      }
    >
      <AlertInformationIcon
        data-testid="ComputedPermissionsTooltip_Icon"
        size={16}
        style={infoIconStyle}
      />
    </Tooltip>
  );
};

ComputedPermissionsTooltip.propTypes = {
  inheritanceInfo: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  inheritedPermissionsInfo: PropTypes.string,
  permissionsIndicatorProps: PropTypes.objectOf(PropTypes.any),
  selectType: PropTypes.string,
};

ComputedPermissionsTooltip.defaultProps = {
  inheritanceInfo: '',
  inheritedPermissionsInfo: '',
  permissionsIndicatorProps: null,
  selectType: null,
};

export default ComputedPermissionsTooltip;
